/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  resume(campaignId) {
    return axios.post(`${this.url}/${campaignId}/resume`);
  }

  pause(campaignId) {
    return axios.post(`${this.url}/${campaignId}/pause`);
  }

  restart(campaignId) {
    return axios.post(`${this.url}/${campaignId}/restart`);
  }

  continueNew(campaignId) {
    return axios.post(`${this.url}/${campaignId}/continue_new`);
  }

  getDeliveries(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/deliveries`, { params });
  }

  getReplies(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/replies`, { params });
  }

  deleteDelivery(campaignId, deliveryId) {
    return axios.delete(`${this.url}/${campaignId}/deliveries/${deliveryId}`);
  }

  clearDeliveriesForDate(campaignId, date) {
    return axios.delete(`${this.url}/${campaignId}/deliveries/clear_date`, {
      params: { date },
    });
  }

  exportDeliveries(campaignId, date) {
    return axios.get(`${this.url}/${campaignId}/deliveries/export`, {
      params: { date },
      responseType: 'blob',
    });
  }

  analyticsMetrics(id) {
    return axios.get(`${this.url}/${id}/analytics/metrics`);
  }

  analyticsContacts(id, { status, page } = {}) {
    return axios.get(`${this.url}/${id}/analytics/contacts`, {
      params: { status, page },
    });
  }
}

export default new CampaignsAPI();
